import { render, staticRenderFns } from "./VendorSignupAccount.vue?vue&type=template&id=29868705&scoped=true"
import script from "./VendorSignupAccount.vue?vue&type=script&lang=js"
export * from "./VendorSignupAccount.vue?vue&type=script&lang=js"
import style0 from "./VendorSignupAccount.vue?vue&type=style&index=0&id=29868705&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29868705",
  null
  
)

export default component.exports